module.exports = __webpack_public_path__ + "static/media/2019_composite.b5fa529f.jpg";